import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b048bbb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "search-input" }
const _hoisted_5 = { class: "list-container" }
const _hoisted_6 = {
  key: 0,
  class: "text-center text-muted"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "text-muted text-center",
  "data-test": "su-no-results"
}, "No matching results.", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "user-text" }
const _hoisted_13 = { class: "user-text email" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "col-sm-12" }

import axios from "axios";
import { computed, ref, watch } from "vue";
import { AdminSearchResults } from "../../../views/admin/admin-search-page.vue";
import { ShortUserDetailsApiModel } from "../../../api-models";

interface Props {
  existingMembers: ShortUserDetailsApiModel[];
  errors?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'search-users',
  props: {
    existingMembers: {},
    errors: {}
  },
  emits: ["select-user", "update-search-state"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const searchText = ref("");

const searchResults = ref<ShortUserDetailsApiModel[] | null>(null);

const selectedUser = ref<ShortUserDetailsApiModel | null>(null);

const serverCallTimeout = ref<any>(null);

const isLoading = ref(false);

const filteredResults = computed<ShortUserDetailsApiModel[] | null>(() => {
  if (!searchResults.value) {
    return null;
  }

  const existingMemberIds = props.existingMembers.map((m) => {
    return m.id;
  });
  return searchResults.value.filter((u) => !existingMemberIds?.includes(u.id));
});

const selectUser = (selection: ShortUserDetailsApiModel): void => {
  emit("select-user", selection);
};

const searchUsers = (): void => {
  if (!searchText.value || searchText.value.trim().length < 3) {
    searchResults.value = null;
    return;
  }
  if (serverCallTimeout.value) {
    clearTimeout(serverCallTimeout.value);
  }

  serverCallTimeout.value = setTimeout(async () => {
    const query = searchText.value.trim();
    searchResults.value = [];
    selectedUser.value = null;
    isLoading.value = true;
    serverCallTimeout.value = null;
    const response = await axios.get(`/admin/search/query?q=${query}`);
    const results = response.data as AdminSearchResults;
    searchResults.value = results?.Users;
    isLoading.value = false;
  }, 500);
};

watch(searchText, (newSearchText) => {
  if (newSearchText) {
    searchUsers();
  }
});

watch(isLoading, () => {
  emit("update-search-state", isLoading.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            class: "form-control",
            placeholder: "Search...",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
            "data-test": "su-search-users",
            "aria-label": "Search for users to assign..."
          }, null, 512), [
            [_vModelText, searchText.value]
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            (filteredResults.value === null && !isLoading.value)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_6, " Search for users to assign... "))
              : (filteredResults.value === null && isLoading.value)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_7, " Searching... "))
                : _createCommentVNode("", true),
            (filteredResults.value && !isLoading.value && filteredResults.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredResults.value, (result) => {
              return (_openBlock(), _createElementBlock("div", {
                key: result.id,
                class: "user-list-item",
                "data-test": "su-results"
              }, [
                _createElementVNode("button", {
                  class: "btn btn-default",
                  style: {"width":"100%"},
                  onClick: ($event: any) => (selectUser(result)),
                  type: "button"
                }, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(result.firstName) + " " + _toDisplayString(result.lastName), 1),
                  _createElementVNode("span", _hoisted_13, "<" + _toDisplayString(result.email) + ">", 1),
                  (result.organisation)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["organisation label", result === selectedUser.value ? 'label-primary' : 'label-default'])
                      }, _toDisplayString(result.organisation.name), 3))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_11)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    (props.errors && props.errors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "col-sm-12 text-danger text-left",
                key: error,
                "data-test": "su-error"
              }, _toDisplayString(error), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})